export const secureEmailConstants = {
  SECURE_MAIL_ATTACHMENT_TYPE_CREATE: "create",
  SECURE_MAIL_ATTACHMENT_TYPE_REPLY: "reply",

  SECURE_MAIL_DRAFT_CLEAR: "SECURE_MAIL_DRAFT_CLEAR",

  SECURE_EMAIL_SEND_INITIATE_REQUEST: "SECURE_EMAIL_SEND_INITIATE_REQUEST",
  SECURE_EMAIL_SEND_INITIATE_COMPLETE: "SECURE_EMAIL_SEND_INITIATE_COMPLETE",
  SECURE_EMAIL_SEND_INITIATE_ERROR: "SECURE_EMAIL_SEND_INITIATE_ERROR",

  SECURE_EMAIL_SEND_REQUEST: "SECURE_EMAIL_SEND_REQUEST",
  SECURE_EMAIL_SEND_COMPLETE: "SECURE_EMAIL_SEND_COMPLETE",
  SECURE_EMAIL_SEND_ERROR: "SECURE_EMAIL_SEND_ERROR",

  SECURE_EMAIL_SAVE_TO_DRAFT_REQUEST: "SECURE_EMAIL_SAVE_TO_DRAFT_REQUEST",
  SECURE_EMAIL_SAVE_TO_DRAFT_COMPLETE: "SECURE_EMAIL_SAVE_TO_DRAFT_COMPLETE",
  SECURE_EMAIL_SAVE_TO_DRAFT_ERROR: "SECURE_EMAIL_SAVE_TO_DRAFT_ERROR",
  SECURE_EMAIL_SET_DRAFT_VALUES: "SECURE_EMAIL_SET_DRAFT_VALUES",

  SECURE_EMAIL_DRAFT_PAYLOAD: "SECURE_EMAIL_DRAFT_PAYLOAD",
  SECURE_EMAIL_CLEAR_DATA: "SECURE_EMAIL_CLEAR_DATA",

  SECURE_MAIL_LIST_REQUEST: "SECURE_MAIL_LIST_REQUEST",
  SECURE_MAIL_LIST_COMPLETE: "SECURE_MAIL_LIST_COMPLETE",
  SECURE_MAIL_LIST_ERROR: "SECURE_MAIL_LIST_ERROR",

  SECURE_MAIL_DRAFT_LIST_REQUEST: "SECURE_MAIL_DRAFT_LIST_REQUEST",
  SECURE_MAIL_DRAFT_LIST_COMPLETE: "SECURE_MAIL_DRAFT_LIST_COMPLETE",
  SECURE_MAIL_DRAFT_LIST_ERROR: "SECURE_MAIL_DRAFT_LIST_ERROR",

  SECURE_MAIL_DELETE_REQUEST: "SECURE_MAIL_DELETE_REQUEST",
  SECURE_MAIL_DELETE_COMPLETE: "SECURE_MAIL_DELETE_COMPLETE",
  SECURE_MAIL_DELETE_ERROR: "SECURE_MAIL_DELETE_ERROR",

  SECURE_MAIL_MESSAGE_LIST_REQUEST: "SECURE_MAIL_MESSAGE_LIST_REQUEST",
  SECURE_MAIL_MESSAGE_LIST_COMPLETE: "SECURE_MAIL_MESSAGE_LIST_COMPLETE",
  SECURE_MAIL_MESSAGE_LIST_ERROR: "SECURE_MAIL_MESSAGE_LIST_ERROR",

  SECURE_MAIL_REPLY_REQUEST: "SECURE_MAIL_REPLY_REQUEST",
  SECURE_MAIL_REPLY_COMPLETE: "SECURE_MAIL_REPLY_COMPLETE",
  SECURE_MAIL_REPLY_ERROR: "SECURE_MAIL_REPLY_ERROR",

  SECURE_MAIL_SINGLE_NOTIFY_REQUEST: "SECURE_MAIL_SINGLE_NOTIFY_REQUEST",
  SECURE_MAIL_SINGLE_NOTIFY_COMPLETE: "SECURE_MAIL_SINGLE_NOTIFY_COMPLETE",
  SECURE_MAIL_SINGLE_NOTIFY_ERROR: "SECURE_MAIL_SINGLE_NOTIFY_ERROR",

  SECURE_MAIL_NOTIFY_REQUEST: "SECURE_MAIL_NOTIFY_REQUEST",
  SECURE_MAIL_NOTIFY_COMPLETE: "SECURE_MAIL_NOTIFY_COMPLETE",
  SECURE_MAIL_NOTIFY_ERROR: "SECURE_MAIL_NOTIFY_ERROR",

  SECURE_MAIL_FILE_UPLOAD_REQUEST: "SECURE_MAIL_FILE_UPLOAD_REQUEST",
  SECURE_MAIL_FILE_UPLOAD_COMPLETE: "SECURE_MAIL_FILE_UPLOAD_COMPLETE",
  SECURE_MAIL_FILE_UPLOAD_ERROR: "SECURE_MAIL_FILE_UPLOAD_ERROR",
  SECURE_MAIL_FILE_UPLOAD_REMOVE: "SECURE_MAIL_FILE_UPLOAD_REMOVE",

  SECURE_MAIL_FILE_DELETE_REQUEST: "SECURE_MAIL_FILE_DELETE_REQUEST",
  SECURE_MAIL_FILE_DELETE_COMPLETE: "SECURE_MAIL_FILE_DELETE_COMPLETE",
  SECURE_MAIL_FILE_DELETE_ERROR: "SECURE_MAIL_FILE_DELETE_ERROR",

  SECURE_MAIL_FILE_DOWNLOAD_REQUEST: "SECURE_MAIL_FILE_DOWNLOAD_REQUEST",
  SECURE_MAIL_FILE_DOWNLOAD_COMPLETE: "SECURE_MAIL_FILE_DOWNLOAD_COMPLETE",
  SECURE_MAIL_FILE_DOWNLOAD_ERROR: "SECURE_MAIL_FILE_DOWNLOAD_ERROR",

  SECURE_MAIL_SEND_OTP_REQUEST: "SECURE_MAIL_SEND_OTP_REQUEST",
  SECURE_MAIL_SEND_OTP_COMPLETE: "SECURE_MAIL_SEND_OTP_COMPLETE",
  SECURE_MAIL_SEND_OTP_ERROR: "SECURE_MAIL_SEND_OTP_ERROR",

  SECURE_MAIL_RESEND_OTP_REQUEST: "SECURE_MAIL_RESEND_OTP_REQUEST",
  SECURE_MAIL_RESEND_OTP_COMPLETE: "SECURE_MAIL_RESEND_OTP_COMPLETE",
  SECURE_MAIL_RESEND_OTP_ERROR: "SECURE_MAIL_RESEND_OTP_ERROR",

  SECURE_MAIL_MESSAGE_CLOSED_REQUEST: "SECURE_MAIL_MESSAGE_CLOSED_REQUEST",
  SECURE_MAIL_MESSAGE_CLOSED_COMPLETE: "SECURE_MAIL_MESSAGE_CLOSED_COMPLETE",
  SECURE_MAIL_MESSAGE_CLOSED_ERROR: "SECURE_MAIL_MESSAGE_CLOSED_ERROR",

  MAX_ATTACHMENT_COUNT: 5,
  ACTION_TYPE_SECUREMAIL_OTP_SEND: "secure_mail_send_otp",
  SECURE_MAIL_MAX_MESSAGE_LENGTH: 85,

  SECURE_MAIL_CLEAR_MESSAGE_LIST: "SECURE_MAIL_CLEAR_MESSAGE_LIST",

  USER_TYPE_CUSTOMER: "CUSTOMER",
  USER_TYPE_ADMIN: "ADMIN",

  SECURE_MAIL_STATUS_CLOSE: "CLOSE",

  STATUS_YES: "Y",
  STATUS_NO: "N",

  SECUREMAIL_SERVICE_TYPE_DELETE: "delete",
  SECUREMAIL_SERVICE_TYPE_RESTORE: "restore",
  SECUREMAIL_SERVICE_TYPE_SEND: "send",

  BYTE_SIZE: 1024,

  MULTI_SELECT_SECUREMAIL_MIN_LENGTH: 2,
  SECUREMAIL_ADMIN_DISPLAY_NAME: "Bank Admin",
  SECUREMAIL_ADMIN_SIGNATURE: "Digital Banking Center",

  UPLOAD_FILE_TYPE_PDF: "pdf",
  UPLOAD_FILE_TYPE_JPEG: "jpeg",
  UPLOAD_FILE_TYPE_JPG: "jpg",
  UPLOAD_FILE_TYPE_WORD: "docx",
  UPLOAD_FILE_TYPE_DOC: "doc",
  UPLOAD_FILE_TYPE_XLS: "xls",
  UPLOAD_FILE_TYPE_XLSX: "xlsx",
  UPLOAD_FILE_TYPE_PNG: "png",
  UPLOAD_FILE_TYPE_PNG_CAP: "PNG",
};
